// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","CategoriesList":"bg_a bhu_cw bhu_jx bhu_jo bhu_vf"};